<template>
    <div class="main_container">
        <comp_filters></comp_filters>
        <comp_modal_overlay></comp_modal_overlay>
    </div>
</template>

<script>
import App from './../application.js'
import comp_filters from './comp_filters.vue'
import comp_modal_overlay from './comp_modal_overlay.vue'

export default {
    components:{
        comp_filters,
        comp_modal_overlay
    },
    data: function () {
        return {
            App: App
        }
    }
}
</script>

<style>
</style>